export const RnRedirectionRoutes = {
  dashboard : '/orders',
  reports: '/reports',
  table_service : '/tableservice',
  tables: '/tables',
  menu : '/menu',
  analytics : '/analytics',
  sections_printers: '/section-counters',
  inventory: '/inventory',
  promotions: '/discounts',
  help: '/help-center',
  lock: '/lock',
  edit_restaurant_details: '/restaurant/restaurant-details'
}
